import React from 'react';

interface CustomNode {
  name: string;
  attribs?: {
    href?: string;
    download?: string;
  };
}

export function NotificationsAnchor(cls: Record<string, string>) {
  return function CustomAnchor(node: CustomNode, children: React.ReactNode) {
    const link = node?.attribs?.href;
    const download = node?.attribs?.download;

    if (!link) {
      return <span>{children}</span>;
    }

    if (download === 'true') {
      return (
        <a
          download={true}
          key={`${node.name}-${link}`}
          className={cls.anchor}
          href={process.env.PUBLIC_URL + link}
          onClick={(event) => event.stopPropagation()}
        >
          {children}
        </a>
      );
    }

    return (
      <a
        href={link}
        key={`${node.name}-${link}`}
        className={cls.anchor}
        onClick={(event) => {
          event.stopPropagation();
        }}
      >
        {children}
      </a>
    );
  };
}
